export function resolveSystemUserName(
  user: { employee_data?: { name?: string } | null } | null | undefined,
  fallback: string
): string {
  return user?.employee_data?.name ?? fallback;
}
